// fetch("https://uuapi.rerrkvifj.com/cfd/query/v1.0/KLine?instrumentID=DUCKUSDT&exchangeID=Exchange&count=1000&type=1m", {
//   "headers": {
//     "accept": "application/json, text/plain, */*",
//     "accept-language": "en-US",
//     "businessversioncode": "201",
//     "content-encoding": "deflate; g-zip",
//     "ex-browser-name": "Chrome",
//     "ex-browser-version": "141.0.0.0",
//     "ex-client-source": "WEB",
//     "ex-client-type": "WEB",
//     "ex-currency": "USD-%24",
//     "ex-device-id": "P083n5gGfTXdIh3hIWgICMRzQwGdTwy3",
//     "ex-language": "en-US",
//     "ex-language-zh": "%E8%8B%B1%E8%AF%AD",
//     "ex-os-name": "Mac OS",
//     "ex-os-version": "10.15.7",
//     "ex-time-zone": "UTC+7",
//     "ex-timestamp": "1760513794292",
//     "ex-token": "d372ac0b1e1246e38704fa35d6d6858c",
//     "ex-uid": "LBA1G59109",
//     "priority": "u=1, i",
//     "sec-ch-ua": "\"Google Chrome\";v=\"141\", \"Not?A_Brand\";v=\"8\", \"Chromium\";v=\"141\"",
//     "sec-ch-ua-mobile": "?0",
//     "sec-ch-ua-platform": "\"macOS\"",
//     "sec-fetch-dest": "empty",
//     "sec-fetch-mode": "cors",
//     "sec-fetch-site": "cross-site",
//     "source": "4",
//     "versionflage": "true"
//   },
//   "referrer": "https://www.lbank.com/",
//   "body": null,
//   "method": "GET",
//   "mode": "cors",
//   "credentials": "omit"
// });

// const lbankFutures = () => {
//   return {
//     getKlines: async (symbol, interval, limit) => {
//       const response = await fetch(`https://uuapi.rerrkvifj.com/cfd/query/v1.0/KLine?instrumentID=${symbol}&exchangeID=Exchange&count=${limit}&type=${interval}`);
//       return response.json();
//     },
//   };
// };

// export default lbankFutures;

// src/hooks/klines/adapters/lbankFutures.js
/* eslint-disable no-console */

const L = (...a) => console.log("[lbank:futures]", ...a);

const PROXYLESS_URL = "https://uuapi.rerrkvifj.com/cfd/query/v1.0/KLine";

/**
 * Число из строки/числа
 */
function toNum(v) {
  const n = typeof v === "string" ? Number(v) : +v;
  return Number.isFinite(n) ? n : NaN;
}

/**
 * Полный набор заголовков как в примере пользователя.
 * Можно переопределить/добавить через headersOverride.
 */
function buildHeaders(headersOverride = {}) {
  return {
    accept: "application/json, text/plain, */*",
    "accept-language": "en-US",
    businessversioncode: "201",
    "content-encoding": "deflate; g-zip",
    "ex-browser-name": "Chrome",
    "ex-browser-version": "141.0.0.0",
    "ex-client-source": "WEB",
    "ex-client-type": "WEB",
    "ex-currency": "USD-%24",
    "ex-device-id": "P083n5gGfTXdIh3hIWgICMRzQwGdTwy3",
    "ex-language": "en-US",
    "ex-language-zh": "%E8%8B%B1%E8%AF%AD",
    "ex-os-name": "Mac OS",
    "ex-os-version": "10.15.7",
    "ex-time-zone": "UTC+7",
    // эти два параметра часто динамические — при необходимости передай свои в headersOverride
    "ex-timestamp": "1760513794292",
    "ex-token": "d372ac0b1e1246e38704fa35d6d6858c",
    "ex-uid": "LBA1G59109",
    priority: "u=1, i",
    "sec-ch-ua": "\"Google Chrome\";v=\"141\", \"Not?A_Brand\";v=\"8\", \"Chromium\";v=\"141\"",
    "sec-ch-ua-mobile": "?0",
    "sec-ch-ua-platform": "\"macOS\"",
    "sec-fetch-dest": "empty",
    "sec-fetch-mode": "cors",
    "sec-fetch-site": "cross-site",
    source: "4",
    versionflage: "true",
    ...headersOverride,
  };
}

/**
 * Нормализация ответа LBank → [{ time, open, high, low, close }]
 * Поддерживает массив объектов LBank:
 * {
 *   "Volume":"61.758","OpenPrice":"3847.59","Turnover":"237455.37188",
 *   "BeginTime":1761022500,"LowestPrice":"3843.01","HighestPrice":"3847.59",
 *   "PeriodID":"1m","InstrumentID":"ETHUSDT","ClosePrice":"3843.87","ExchangeID":"Exchange"
 * }
 * а также fallback на разные варианты полей.
 */
export function normalizeKlines(resp) {
  L("raw response", resp);

  const data =
    resp?.data?.klineData ??
    resp?.data?.data ??
    resp?.data?.list ??
    resp?.data ??
    resp?.result ??
    resp?.klines ??
    resp;

  const arr = Array.isArray(data) ? data : (Array.isArray(data?.items) ? data.items : []);
  if (!Array.isArray(arr) || arr.length === 0) {
    L("normalizeKlines: empty or non-array", { hasData: !!data });
    return [];
  }

  const out = [];

  for (const it of arr) {
    // поддержка «объектного» формата LBank
    const t =
      toNum(it.BeginTime ?? it.ts ?? it.time ?? it.t ?? it.openTime ?? it.startTime ?? it.timestamp);
    const o = toNum(it.OpenPrice  ?? it.o ?? it.open);
    const h = toNum(it.HighestPrice ?? it.h ?? it.high);
    const l = toNum(it.LowestPrice  ?? it.l ?? it.low);
    const c = toNum(it.ClosePrice ?? it.c ?? it.close);

    if ([t, o, h, l, c].every(Number.isFinite)) {
      out.push({ time: t, open: o, high: h, low: l, close: c });
      continue;
    }

    // на всякий случай — поддержка массивов [t,o,h,l,c]
    if (Array.isArray(it)) {
      const tt = toNum(it[0]);
      const oo = toNum(it[1]);
      const hh = toNum(it[2]);
      const ll = toNum(it[3]);
      const cc = toNum(it[4]);
      if ([tt, oo, hh, ll, cc].every(Number.isFinite)) {
        out.push({ time: tt, open: oo, high: hh, low: ll, close: cc });
      }
    }
  }

  // LBank отдаёт время в секундах → если < 2e10, домножим до мс
  const secondsLikely = out.length > 0 && out[0].time < 2e10;
  if (secondsLikely) for (const c of out) c.time *= 1000;

  // Сортируем и отсекаем дубликаты по времени (на всякий случай)
  out.sort((a, b) => a.time - b.time);
  const dedup = [];
  let lastT = -1;
  for (const c of out) {
    if (c.time !== lastT) { dedup.push(c); lastT = c.time; }
    else dedup[dedup.length - 1] = c; // если совпало — перезапишем последней версией
  }

  L("normalized sample", {
    count: dedup.length,
    first: dedup[0],
    last: dedup[dedup.length - 1],
  });

  return dedup;
}

/**
 * История свечей (REST)
 * ВАЖНО: interval — как пропс, т.к. у нас разные интервалы.
 */
export async function lbankFuturesFetchHistory({
  symbol,
  interval,
  limit = 300,
  headers: headersOverride,
} = {}) {
  const url =
    `${PROXYLESS_URL}?instrumentID=${encodeURIComponent(symbol)}` +
    `&exchangeID=Exchange&count=${encodeURIComponent(limit)}` +
    `&type=${encodeURIComponent(interval)}`;

  L("[lbankFut REST] fetch", { symbol, interval, limit, url, headers: headersOverride });

  const resp = await fetch(url, {
    method: "GET",
    mode: "cors",
    credentials: "omit",
    headers: buildHeaders(headersOverride),
    referrer: "https://www.lbank.com/",
  });

  // если ответ не ок — пусть свалится, чтобы увидеть код
  if (!resp.ok) {
    throw new Error(`[LBank FUT] HTTP ${resp.status}`);
  }

  const json = await resp.json().catch(() => ({}));
  const candles = normalizeKlines(json);

  L("[lbankFut REST] done", {
    symbol,
    interval,
    count: candles.length,
    first: candles[0],
    last: candles[candles.length - 1],
  });

  return candles;
}

/**
 * «WS»-поллинг REST каждые pollMs — совместимый интерфейс
 * (если захочешь — можно не использовать, current hook его не включает).
 */
export function lbankFuturesOpenWS({
  symbol,
  interval = "1m",
  onBar,
  pollMs = 2000,
  headers,
}) {
  let timer = null;
  let lastTs = 0;

  async function tick() {
    try {
      const arr = await lbankFuturesFetchHistory({ symbol, interval, limit: 3, headers });
      if (!Array.isArray(arr) || arr.length === 0) return;
      const last = arr[arr.length - 1];
      if (!last?.time) return;

      // шлём последнюю всегда — твой upsert в хуке сам разрулит корзины
      onBar?.(last);

      // если сменился таймслот — докинем и предпоследнюю, чтобы не потерять close
      if (last.time !== lastTs && arr.length >= 2) {
        const prev = arr[arr.length - 2];
        if (prev?.time) onBar?.(prev);
        lastTs = last.time;
      }
    } catch (e) {
      L("poll error", e?.message || e);
    }
  }

  tick();
  timer = setInterval(tick, pollMs);

  return () => {
    if (timer) clearInterval(timer);
    timer = null;
  };
}

export default {
  lbankFuturesFetchHistory,
  lbankFuturesOpenWS, // можно не использовать
};
